import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonTypes } from 'src/app/enums/button-type.enum';
import { Button } from 'src/app/models/button.model';
import { ModalContent } from 'src/app/models/modal-content.model';

@Component({
  selector: 'lns-location-modal',
  templateUrl: './location-modal.component.html',
  styleUrls: ['./location-modal.component.scss']
})
export class LocationModalComponent {
  @Input() modalContent!: ModalContent;
  @Output() closeModal = new EventEmitter();
  locationLink: string;

  backButton: Button = {
    type: ButtonTypes.TransparentGrayText
  };

  confirmLinkButton: Button = {
    type: ButtonTypes.Primary,
    iml: '8',
    submitBtn: true
  };

  constructor() {
    this.locationLink = 'https://www.gbkr.si/poslovalnice-in-bankomati/';
  }

  openLink(url: any): void {
    window.open(url, '_blank');
    this.closeModal.emit();
  }

  onBack(): void {
    this.closeModal.emit();
  }
}
